import React from 'react';
import { useFragment } from 'react-relay/hooks';

import { Theme } from '@material-ui/core';
import { createStyles, withStyles, WithStyles } from '@material-ui/core/styles';
import { graphql } from 'babel-plugin-relay/macro';
import { ToolbarNavigation, ToolbarNavigationProps, Typography } from 'embeds/components';

import { ToolbarNavigationPatient_EmbedPatient$key } from './__generated__/ToolbarNavigationPatient_EmbedPatient.graphql';
import AvatarNode from './AvatarNode';
import TypographyNodeDob from './TypographyNodeDob';
import TypographyNodeName from './TypographyNodeName';

const styles = ({ spacing: { unit } }: Theme) =>
  createStyles({
    paddingLeft: {
      paddingLeft: unit,
    },
  });

export interface ToolbarNavigationPatientProps
  extends WithStyles<typeof styles>,
    Omit<ToolbarNavigationProps, 'classes'> {
  fragmentRef: ToolbarNavigationPatient_EmbedPatient$key;
}

const ToolbarNavigationPatient: React.FC<ToolbarNavigationPatientProps> = ({ classes, fragmentRef, ...rest }) => {
  const patient = useFragment<ToolbarNavigationPatient_EmbedPatient$key>(
    graphql`
      fragment ToolbarNavigationPatient_EmbedPatient on Patient {
        _id
        ...AvatarNode_EmbedNode
        ...TypographyNodeName_EmbedNode
        ...TypographyNodeDob_EmbedNode
      }
    `,
    fragmentRef,
  );

  const shouldOpenInANewTab = window.location.pathname.includes('telehealth');

  return (
    <ToolbarNavigation {...rest}>
      <Typography
        variant="inherit"
        color="inherit"
        to={`/patients/${patient._id}/chat`}
        shouldOpenInANewTab={shouldOpenInANewTab}
      >
        <AvatarNode fragmentRef={patient} size="xsmall" />
      </Typography>
      <TypographyNodeName
        fragmentRef={patient}
        className={classes.paddingLeft}
        color="inherit"
        to={`/patients/${patient._id}/chat`}
        shouldOpenInANewTab={shouldOpenInANewTab}
        variant="body1LargeStrongBold"
        noWrap
        inline
      />
      <TypographyNodeDob className={classes.paddingLeft} fragmentRef={patient} variant="caption" inline />
    </ToolbarNavigation>
  );
};

export default withStyles(styles)(ToolbarNavigationPatient);
